import React from "react";
import { useNavigate } from "react-router-dom";

export const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <i className="bi bi-shield-exclamation text-warning" style={{ fontSize: "5rem" }}></i>
              </div>
              <h1 className="display-4 mb-3">Acesso Negado</h1>
              <p className="lead text-muted mb-4">
                Você não tem permissão para acessar esta página.
              </p>
              <hr className="my-4" />
              <div className="d-flex flex-column gap-3">
                <p className="text-muted mb-0">
                  Se você acredita que deveria ter acesso a esta funcionalidade, 
                  entre em contato com o administrador do sistema para solicitar 
                  as permissões necessárias.
                </p>
                <div className="d-flex gap-2 justify-content-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Voltar
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate("/")}
                  >
                    <i className="bi bi-house me-2"></i>
                    Ir para o Início
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Informações adicionais */}
          <div className="card mt-4 shadow-sm">
            <div className="card-header bg-light">
              <h5 className="mb-0">
                <i className="bi bi-info-circle me-2"></i>
                Sobre Permissões
              </h5>
            </div>
            <div className="card-body">
              <p className="mb-2">
                <strong>O que são permissões?</strong>
              </p>
              <p className="text-muted small mb-3">
                Permissões controlam o acesso a diferentes funcionalidades do sistema. 
                Elas são definidas pelos administradores de acordo com o cargo e 
                responsabilidades de cada usuário.
              </p>

              <p className="mb-2">
                <strong>Como solicitar acesso?</strong>
              </p>
              <ul className="text-muted small mb-0">
                <li>Entre em contato com o administrador do sistema</li>
                <li>Explique qual funcionalidade você precisa acessar</li>
                <li>Informe o motivo da solicitação</li>
                <li>Aguarde a aprovação e atribuição das permissões</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
